export const messages = {
  en: {
    myAuditComplaints: {
      title: 'Complaint Audit',
      complaintId: 'Complaint ID',
      complaintType: 'Complaint Type',
      houseInfo: 'House Info',
      complainant: 'Complainant',
      phone: 'Phone',
      status: 'Status',
      operation: 'Operation',
      audit: 'Audit',
      modify: 'Modify',
      resubmit: 'Resubmit',
      finish: 'Finish',
      detail: 'Detail',
      auditDialog: {
        title: 'Audit Information',
        status: 'Audit Status',
        statusPlaceholder: 'Please select audit status',
        reason: 'Reason',
        reasonPlaceholder: 'Required, please fill in the reason',
        submit: 'Submit',
        cancel: 'Cancel'
      },
      editDialog: {
        title: 'Edit Complaint',
        type: 'Complaint Type',
        typePlaceholder: 'Required, please select complaint type',
        name: 'Complainant',
        namePlaceholder: 'Required, please fill in complainant',
        phonePlaceholder: 'Required, please fill in phone number',
        content: 'Complaint Content',
        contentPlaceholder: 'Required, please fill in complaint content',
        save: 'Save',
        cancel: 'Cancel'
      },
      confirmDialog: {
        title: 'Please Confirm Your Operation',
        resubmitMsg: 'Are you sure to resubmit?',
        finishMsg: 'Are you sure to finish the process?',
        confirm: 'Confirm',
        cancel: 'Cancel'
      },
      detailDialog: {
        title: 'Complaint Detail',
        houseInfo: 'House Information',
        complaintCode: 'Complaint Code',
        complaintType: 'Complaint Type',
        complainant: 'Complainant',
        phone: 'Phone',
        status: 'Status',
        handler: 'Handler',
        handlerPhone: 'Handler Phone',
        handlerId: 'Handler ID',
        content: 'Complaint Content',
        photos: 'Complaint Photos',
        processRecords: 'Process Records',
        sequence: 'No.',
        processor: 'Processor',
        processStatus: 'Status',
        processTime: 'Process Time',
        duration: 'Duration',
        comment: 'Comment',
        close: 'Close'
      }
    }
  },
  zh: {
    myAuditComplaints: {
      title: '投诉审核',
      complaintId: '投诉ID',
      complaintType: '投诉类型',
      houseInfo: '房屋信息',
      complainant: '投诉人',
      phone: '投诉电话',
      status: '投诉状态',
      operation: '操作',
      audit: '审核',
      modify: '修改',
      resubmit: '重新提交',
      finish: '结束',
      detail: '详情',
      auditDialog: {
        title: '审核信息',
        status: '审核状态',
        statusPlaceholder: '请选择审核状态',
        reason: '原因',
        reasonPlaceholder: '必填，请填写原因',
        submit: '提交',
        cancel: '取消'
      },
      editDialog: {
        title: '修改投诉',
        type: '投诉类型',
        typePlaceholder: '必填，请选择投诉类型',
        name: '投诉人',
        namePlaceholder: '必填，请填写投诉人',
        phonePlaceholder: '必填，请填写投诉电话',
        content: '投诉内容',
        contentPlaceholder: '必填，请填写投诉内容',
        save: '保存',
        cancel: '取消'
      },
      confirmDialog: {
        title: '请确认您的操作',
        resubmitMsg: '您确定重新提交吗？',
        finishMsg: '您确定结束流程吗？',
        confirm: '确认',
        cancel: '取消'
      },
      detailDialog: {
        title: '投诉详情',
        houseInfo: '房屋信息',
        complaintCode: '投诉编码',
        complaintType: '投诉类型',
        complainant: '投诉人',
        phone: '投诉电话',
        status: '投诉状态',
        handler: '处理人',
        handlerPhone: '处理人电话',
        handlerId: '处理人编号',
        content: '投诉内容',
        photos: '投诉图片',
        processRecords: '处理记录',
        sequence: '序号',
        processor: '处理人',
        processStatus: '状态',
        processTime: '处理时间',
        duration: '耗时',
        comment: '意见',
        close: '关闭'
      }
    }
  }
}